/**
 * API Configuration
 *
 * All service URLs are derived from a single base URL (REACT_APP_API_BASE_URL).
 * Set this in your .env file:
 *
 * - REACT_APP_API_BASE_URL: Base domain for all APIs (e.g. https://api.nerdbase.cloud)
 */

interface ApiConfig {
  API_BASE_URL: string;
  AUTH_API_BASE_URL: string;
  FINANCE_API_BASE_URL: string;
  CUSTOMER_CREDIT_API_BASE_URL: string;
  ORDER_API_BASE_URL: string;
  GAME_CATALOG_API_BASE_URL: string;
  RAZER_GOLD_WALLET_API_BASE_URL: string;
  CRYPTO_PAYMENT_API_BASE_URL: string;
  CUSTOMER_AUTH_API_BASE_URL: string;
  CMS_API_BASE_URL: string;
  ENV: string;
}

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.nerdbase.cloud';

const config: ApiConfig = {
  API_BASE_URL: BASE_URL,
  AUTH_API_BASE_URL: `${BASE_URL}/auth/api/v1`,
  FINANCE_API_BASE_URL: `${BASE_URL}/finance/api/v1`,
  CUSTOMER_CREDIT_API_BASE_URL: `${BASE_URL}/customer-credit/api/v1`,
  ORDER_API_BASE_URL: `${BASE_URL}/order/api/v1`,
  GAME_CATALOG_API_BASE_URL: `${BASE_URL}/game-catalog/api/v1`,
  RAZER_GOLD_WALLET_API_BASE_URL: `${BASE_URL}/razer-gold-wallet/api/v1`,
  CRYPTO_PAYMENT_API_BASE_URL: `${BASE_URL}/crypto-payment/api/v1`,
  CUSTOMER_AUTH_API_BASE_URL: `${BASE_URL}/customer-auth/api/v1`,
  CMS_API_BASE_URL: `${BASE_URL}/cms/api/v1`,
  ENV: process.env.REACT_APP_ENV || 'production',
};

export default config;
